import { UserBookingDetailsQuery } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import { Row, Col } from 'react-bootstrap';
import Truncate from '@website/components/utilities/Truncate';

/**
 * User Booking Details - Itinerary Section
 */
export default function Itinerary({
  booking,
}: {
  booking: Pick<UserBookingDetailsQuery['booking'], 'trip' | 'group'>;
}) {
  const itineraryItems = booking.trip.itinerary.items;

  const startDate = DateTime.fromISO(booking.group.start.utc, {
    zone: booking.group.start.zone,
  });

  return (
    <div className="text-block">
      <h5 className="mb-4">
        {itineraryItems.length} Epic day{itineraryItems.length > 1 ? 's' : ''}
      </h5>

      {itineraryItems &&
        itineraryItems.map(({ id, day, title, description }) => {
          const dayDate = startDate.plus({ days: day - 1 });

          return (
            <Row key={id} className="mb-3">
              <Col className="d-flex align-items-top mb-3">
                <div className="date-tile me-3 px-4 sha">
                  <div className="text-uppercase">
                    <span className="text-sm">{dayDate.toFormat('LLL')}</span>
                    <br />
                    <strong className="text-lg">{dayDate.toFormat('d')}</strong>
                  </div>
                </div>
                <div>
                  <h6>
                    {dayDate.toFormat('cccc')}: {title}
                  </h6>
                  <Truncate lines={3} enableExpand className="small mb-0">
                    {description}
                  </Truncate>
                </div>
              </Col>
            </Row>
          );
        })}
    </div>
  );
}
